import { render, staticRenderFns } from "./AllTransfers.vue?vue&type=template&id=f8a95e46"
import script from "./AllTransfers.vue?vue&type=script&lang=js"
export * from "./AllTransfers.vue?vue&type=script&lang=js"
import style0 from "./AllTransfers.vue?vue&type=style&index=0&id=f8a95e46&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports